var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25629_5223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4316 18.7355C28.0651 13.9631 25.8431 10.9724 23.8828 8.3333C22.0677 5.89006 20.5 3.78018 20.5 0.667808C20.5 0.417808 20.36 0.189308 20.138 0.074746C19.9153 -0.0405039 19.6477 -0.021629 19.4453 0.125496C16.5013 2.23212 14.0449 5.78268 13.1869 9.17043C12.5912 11.529 12.5124 14.1805 12.5013 15.9317C9.78256 15.351 9.16669 11.2842 9.16019 11.2399C9.12956 11.029 9.00069 10.8454 8.81319 10.7452C8.62375 10.6462 8.40106 10.6391 8.209 10.7341C8.06644 10.8031 4.70962 12.5087 4.51431 19.3188C4.50062 19.5454 4.5 19.7726 4.5 19.9998C4.5 26.6159 9.88344 31.999 16.5 31.999C16.5091 31.9996 16.5189 32.0009 16.5267 31.999C16.5293 31.999 16.5319 31.999 16.5351 31.999C23.1354 31.98 28.5 26.6042 28.5 19.9998C28.5 19.6671 28.4316 18.7355 28.4316 18.7355ZM16.5 30.6657C14.2942 30.6657 12.5 28.7544 12.5 26.405C12.5 26.3249 12.4994 26.2442 12.5052 26.1452C12.5319 25.1544 12.7201 24.478 12.9264 24.0282C13.3132 24.8589 14.0046 25.6225 15.1276 25.6225C15.4961 25.6225 15.7943 25.3243 15.7943 24.9559C15.7943 24.0067 15.8139 22.9117 16.0502 21.9235C16.2605 21.0472 16.7631 20.115 17.3998 19.3677C17.683 20.3377 18.2351 21.1227 18.7742 21.889C19.5457 22.9852 20.3432 24.1187 20.4832 26.0515C20.4916 26.166 20.5001 26.2813 20.5001 26.405C20.5 28.7544 18.7057 30.6657 16.5 30.6657Z",
    fill: "#E23535"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25629_5223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/Fire.19e4e50b66ae9059b514cff944807976.svg";
export { ForwardRef as ReactComponent };